import React from 'react';

const ToastSuccess = ({ title }) => {
  return (
    <>
      <div className="flex gap-2">
        <div className="flex item-center justify-center min-w-5.25 w-5.25 min-h-5.25 h-5.25 float-left">
          <img className="w-4 h-4 mt-0.5" src={require('assets/resources/CheckCircle.svg').default} alt="icon success" width={16} height={16} />
        </div>
        <div>{title && <p className="text-logo text-sm font-normal">{title}</p>}</div>
      </div>
    </>
  );
};

export default React.memo(ToastSuccess);
